import {
  createEntityAdapter,
  createSelector
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice";

const quotesAdapter = createEntityAdapter();
const initialState = quotesAdapter.getInitialState();

export const quotesApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getQuotes: builder.query({
      query: () => '/api/v1/quotes',
      transformResponse: responseData => {
        console.log(responseData,'responseData')
        const loaded = responseData.data.map(quote => {
          quote.id = quote._id;
          return quote;
        });
        return quotesAdapter.setAll(initialState, loaded);
      },
      providesTags: (result) =>
        result?.ids
          ? [
              { type: 'Quote', id: 'LIST' },
              ...result.ids.map(id => ({ type: 'Quote', id }))
            ]
          : [{ type: 'Quote', id: 'LIST' }],
    }),
    addNewQuote: builder.mutation({
      query: (quoteData) => ({
        url: '/api/v1/quotes',
        method: 'POST',
        body: quoteData
      }),
      invalidatesTags: [{ type: 'Quote', id: 'LIST' }]
    }),
    updateQuote: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/api/v1/quotes/${id}`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: (res, err, arg) => [{ type: 'Quote', id: arg.id }]
    }),
    deleteQuote: builder.mutation({
      query: ({ id }) => ({
        url: `/api/v1/quotes/${id}`,
        method: 'DELETE',
        body: { id }
      }),
      invalidatesTags: (res, err, arg) => [{ type: 'Quote', id: arg.id }]
    })
  })
});

export const {
  useGetQuotesQuery,
  useAddNewQuoteMutation,
  useUpdateQuoteMutation,
  useDeleteQuoteMutation
} = quotesApiSlice;

// ⬇ ये quotesApiSlice.js के सबसे नीचे जोड़ें:

// Selector functions
const quotesResult = quotesApiSlice.endpoints.getQuotes.select();

export const selectQuotesData = createSelector(
  quotesResult,
  (quotesResult) => quotesResult.data ?? initialState
);

// Export entity adapter selectors
export const {
  selectAll: selectAllQuotes,
  selectById: selectQuoteById,
  selectIds: selectQuoteIds,
} = quotesAdapter.getSelectors((state) => selectQuotesData(state));
